module.exports = require('search-ion/lib/injectors');



// WEBPACK FOOTER //
// ./src/ions/search/injectors.js